module.exports={render:function (){with(this) {
  return _h('div', {
    staticClass: "cart-items"
  }, [_m(0), " ", _l((dishsData), function(dishs) {
    return (dishs.orderedDishs.length) ? _h('ul', {
      staticClass: "ordered-dish"
    }, [_l((dishs.orderedDishs), function(dish, dishID) {
      return (dishID !== 'length') ? _h('li', [_h('span', {
        staticClass: "dish-name"
      }, [_s(dishs.dishs[dish.dishIndex].dishName)]), " ", _h('span', {
        staticClass: "dish-price"
      }, ["￥" + _s(dish.dishPrice)]), " ", _h('item-oper', {
        attrs: {
          "dish-num": dish.num,
          "dish-id": dishID,
          "catalog-id": dishs.catalogID
        }
      })]) : _e()
    })]) : _e()
  })])
}},staticRenderFns: [function (){with(this) {
  return _h('ul', {
    staticClass: "cart-index"
  }, [_h('li', ["菜名"]), " ", _h('li', ["单价"]), " ", _h('li', ["数量"])])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ee04a2e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CartItems.vue
 ** module id = 81
 ** module chunks = 1
 **/